import Register from "../Component/Register";
import { connect } from 'react-redux';
import {
  userRegister, verifyRegisterUser
} from '../../../../Action';

const mapStateToProps = (state) => {

  const {
    Register, VerifyRegister
  } = state;

  return {
    Register, VerifyRegister
  }
}
const actionCreators = {
  userRegister,
  verifyRegisterUser
}
export default (connect(mapStateToProps, actionCreators)(Register));